import React from 'react';
import { Route } from 'react-router-dom';
import { createRoute } from '@core/router';
import dashBoardRoute from '@modules/dashboard/DashBoardPage';

const dashBoardRoutes = <Route path="/" {...createRoute(dashBoardRoute)} />;

export default dashBoardRoutes;
